(() => {
  const selectors = {
    root: "[data-fundraising-new]",
    trigger: "[data-fundraising-lightbox-trigger]",
    lightbox: "[data-fundraising-lightbox]",
    image: "[data-fundraising-lightbox-image]",
    title: "[data-fundraising-lightbox-title]",
    text: "[data-fundraising-lightbox-text]",
    close: "[data-fundraising-lightbox-close]",
    previous: "[data-fundraising-lightbox-prev]",
    next: "[data-fundraising-lightbox-next]",
    track: "[data-fundraising-gallery-track]",
    scrollPrevious: "[data-fundraising-gallery-prev]",
    scrollNext: "[data-fundraising-gallery-next]",
  };

  const initialized = window.KLFundraisingNewInitialized || new WeakSet();
  window.KLFundraisingNewInitialized = initialized;

  function initFundraising(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const lightbox = root.querySelector(selectors.lightbox);
    const image = root.querySelector(selectors.image);
    const title = root.querySelector(selectors.title);
    const text = root.querySelector(selectors.text);
    let triggers = [...root.querySelectorAll(selectors.trigger)];
    const closeButton = root.querySelector(selectors.close);
    const previousButton = root.querySelector(selectors.previous);
    const nextButton = root.querySelector(selectors.next);
    const track = root.querySelector(selectors.track);
    const scrollPrevious = root.querySelector(selectors.scrollPrevious);
    const scrollNext = root.querySelector(selectors.scrollNext);
    const galleryControls = root.querySelector(".fundraising-new__gallery-controls");
    const autoplayDelay = Number(root.dataset.galleryAutoplayDelay || 4500);
    let currentIndex = 0;
    let lastFocused = null;
    let autoplayTimer = null;
    let autoplayResumeTimer = null;
    let autoplayPaused = true;
    let pointerOverGallery = false;

    function setLightbox(index) {
      const trigger = triggers[index];
      if (!trigger || !image || !title || !text) return;

      currentIndex = index;
      image.src = trigger.dataset.lightboxImage || "";
      image.alt = trigger.dataset.lightboxTitle || "";
      title.textContent = trigger.dataset.lightboxTitle || "";
      text.textContent = trigger.dataset.lightboxText || "";
    }

    function openLightbox(index) {
      if (!lightbox) return;

      stopAutoplay();
      lastFocused = document.activeElement;
      setLightbox(index);
      lightbox.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      closeButton?.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;

      lightbox.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      if (lastFocused && typeof lastFocused.focus === "function") {
        lastFocused.focus();
      }
      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        pointerOverGallery = false;
        restartAutoplaySoon(120);
      }
    }

    function moveLightbox(direction) {
      if (!triggers.length) return;
      const nextIndex = (currentIndex + direction + triggers.length) % triggers.length;
      setLightbox(nextIndex);
    }

triggers.forEach((trigger, index) => {
  trigger.addEventListener("click", () => {
    const group = trigger.closest("[data-lightbox-group]");

    if (group) {
      triggers = [...group.querySelectorAll(selectors.trigger)];
    } else {
      triggers = [...root.querySelectorAll(selectors.trigger)];
    }

    const currentIndex = triggers.indexOf(trigger);
    openLightbox(currentIndex);
  });
});

    closeButton?.addEventListener("click", closeLightbox);
    previousButton?.addEventListener("click", () => moveLightbox(-1));
    nextButton?.addEventListener("click", () => moveLightbox(1));

    lightbox?.addEventListener("click", (event) => {
      if (event.target === lightbox) closeLightbox();
    });

    root.addEventListener("keydown", (event) => {
      if (!lightbox || lightbox.getAttribute("aria-hidden") === "true") return;

      if (event.key === "Escape") {
        closeLightbox();
      } else if (event.key === "ArrowLeft") {
        moveLightbox(-1);
      } else if (event.key === "ArrowRight") {
        moveLightbox(1);
      }
    });

    const getGalleryCards = () => (track ? [...track.querySelectorAll(".fundraising-new__gallery-card")] : []);

    const getCardLeft = (card) => {
      if (!card || !track) return 0;
      return card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    };

    const hasScrollableGallery = () => Boolean(track && track.scrollWidth > track.clientWidth + 2);

    const getMaxGalleryScroll = () => {
      if (!track) return 0;
      return Math.max(0, track.scrollWidth - track.clientWidth);
    };

    const isGalleryInteractionPaused = () => pointerOverGallery || Boolean(track?.matches(":hover"));

    const updateGalleryControls = () => {
      const hasOverflow = hasScrollableGallery();
      if (galleryControls) galleryControls.hidden = !hasOverflow;
      scrollPrevious?.toggleAttribute("disabled", !hasOverflow);
      scrollNext?.toggleAttribute("disabled", !hasOverflow);
      return hasOverflow;
    };

    const scrollGalleryTo = (index, behavior = "smooth") => {
      const cards = getGalleryCards();
      if (!track || !cards.length || !updateGalleryControls()) return;

      const nextIndex = (index + cards.length) % cards.length;
      const nextLeft = Math.min(getCardLeft(cards[nextIndex]), getMaxGalleryScroll());
      track.scrollTo({ left: nextLeft, behavior });
    };

    const getClosestGalleryIndex = () => {
      const cards = getGalleryCards();
      if (!track || !cards.length) return 0;

      return cards.reduce(
        (best, card, index) => {
          const distance = Math.abs(Math.min(getCardLeft(card), getMaxGalleryScroll()) - track.scrollLeft);
          return distance < best.distance ? { index, distance } : best;
        },
        { index: 0, distance: Number.POSITIVE_INFINITY }
      ).index;
    };

    const scrollGallery = (direction) => {
      const cards = getGalleryCards();
      if (!track || !cards.length || !updateGalleryControls()) return;

      const currentLeft = track.scrollLeft;
      const maxScroll = getMaxGalleryScroll();
      const tolerance = 6;

      if (direction > 0) {
        if (currentLeft >= maxScroll - tolerance) {
          track.scrollTo({ left: 0, behavior: "smooth" });
          return;
        }

        const nextCard = cards.find((card) => Math.min(getCardLeft(card), maxScroll) > currentLeft + tolerance);
        track.scrollTo({ left: nextCard ? Math.min(getCardLeft(nextCard), maxScroll) : 0, behavior: "smooth" });
        return;
      }

      if (currentLeft <= tolerance) {
        track.scrollTo({ left: Math.min(getCardLeft(cards[cards.length - 1]), maxScroll), behavior: "smooth" });
        return;
      }

      const previousCards = cards.filter((card) => getCardLeft(card) < currentLeft - tolerance);
      const previousCard = previousCards[previousCards.length - 1];
      track.scrollTo({
        left: previousCard ? Math.min(getCardLeft(previousCard), maxScroll) : Math.min(getCardLeft(cards[cards.length - 1]), maxScroll),
        behavior: "smooth",
      });
    };

    const stopAutoplay = () => {
      autoplayPaused = true;
      if (autoplayTimer) window.clearTimeout(autoplayTimer);
      if (autoplayResumeTimer) window.clearTimeout(autoplayResumeTimer);
      autoplayTimer = null;
      autoplayResumeTimer = null;
    };

    const startAutoplay = (delay = autoplayDelay) => {
      const cards = getGalleryCards();
      if (!track || cards.length < 2 || autoplayTimer || !updateGalleryControls()) return;

      autoplayPaused = false;
      autoplayTimer = window.setTimeout(() => {
        autoplayTimer = null;
        if (autoplayPaused || isGalleryInteractionPaused() || !updateGalleryControls()) return;

        scrollGallery(1);
        startAutoplay();
      }, Math.max(delay, 4000));
    };

    const restartAutoplaySoon = (delay = 700) => {
      stopAutoplay();
      autoplayResumeTimer = window.setTimeout(startAutoplay, delay);
    };

    scrollPrevious?.addEventListener("click", () => {
      stopAutoplay();
      scrollGallery(-1);
      restartAutoplaySoon();
    });
    scrollNext?.addEventListener("click", () => {
      stopAutoplay();
      scrollGallery(1);
      restartAutoplaySoon();
    });

    track?.addEventListener("pointerenter", () => {
      pointerOverGallery = true;
      stopAutoplay();
    });
    track?.addEventListener("pointerover", () => {
      pointerOverGallery = true;
      stopAutoplay();
    });
    track?.addEventListener("pointerleave", () => {
      pointerOverGallery = false;
      startAutoplay();
    });
    track?.addEventListener("mouseenter", () => {
      pointerOverGallery = true;
      stopAutoplay();
    });
    track?.addEventListener("mouseleave", () => {
      pointerOverGallery = false;
      startAutoplay();
    });
    track?.addEventListener("mouseover", () => {
      pointerOverGallery = true;
      stopAutoplay();
    });
    track?.addEventListener("mouseout", (event) => {
      if (!track.contains(event.relatedTarget)) {
        pointerOverGallery = false;
        startAutoplay();
      }
    });
    window.addEventListener("resize", updateGalleryControls);
    window.addEventListener("resize", () => scrollGalleryTo(getClosestGalleryIndex(), "auto"));
    updateGalleryControls();

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      startAutoplay();
    }
  }

  function initAll() {
    document.querySelectorAll(selectors.root).forEach(initFundraising);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initFundraising(event.target.querySelector(selectors.root));
  });
})();
